import React from 'react';

import AnchorLink from 'react-anchor-link-smooth-scroll';
import './StoreInfoCard.css';

const StoreInfoCard = () => {
  return (
    <div className="store-info-wrapper desktop">
      <div className="store-info-inner">
        <h3>
          Brasserie
          <br />
          du baigneur
        </h3>
        <p>
          8, passage de Provins
          <br />
          74000 ANNECY
        </p>
        <p>
          <span>Visite et vente à emporter</span>
        </p>
        <p>
          Merci de nous contacter
          <br />
          par téléphone ou par{' '}
          <AnchorLink offset="70" href="#contact">
            ici
          </AnchorLink>
          <br />
          pour convenir d’un rendez-vous ou pour
          <br />
          connaître les horaires de la brasserie
        </p>
      </div>
    </div>
  );
};

export default StoreInfoCard;



// WEBPACK FOOTER //
// ./src/Components/StoreInfoCard/StoreInfoCard.js